import React, { useCallback } from 'react';
import { func } from 'prop-types';
import classNames from 'classnames';

import { usePromoCart } from '../../contexts/PromoCartProvider';
import { usePromoModel } from '../../contexts/PromoModelProvider';
import { usePromoPresentation } from '../../contexts/PromoPresentationProvider';
import { noop } from '../../utils/promo-utils';
import { PromoPod } from '../promo-pod/PromoPod';
import { MessagingContainer } from './subcomponents/MessagingContainer/MessagingContainer';
import { InfoContainer } from './subcomponents/InfoContainer/InfoContainer';
import './PromoCallToAction.scss';

export const PromoCallToAction = ({ onPromoCtaHover }) => {
  const { setIsDrawerOpen, isAppleTouchDevice } = usePromoPresentation();
  const {
    isMsb, isBogo, isBmsm, singleItemIdToDisplay, hasProducts, analyticsComponent
  } = usePromoModel();
  const { bogoSelectedProduct, freeItemInCart } = usePromoCart();
  const isCallToActionEnabled = hasProducts && !singleItemIdToDisplay;

  const handleClick = useCallback((event) => {
    const imageContainer = document.querySelector('.promo-images-container');
    if (!imageContainer || !imageContainer.contains(event.target)) {
      onPromoCtaHover();
      setIsDrawerOpen(true);
    }

    // Analytics
    window.LIFE_CYCLE_EVENT_BUS.trigger('promotion-products-cta.click', {
      component: analyticsComponent,
      section: 'buybox',
      target: 'see eligible items',
    });
  }, [onPromoCtaHover, setIsDrawerOpen, analyticsComponent]);

  const promoCallToActionClasses = classNames(
    'promo-call-to-action', {
      'promo-call-to-action--disabled': !isCallToActionEnabled,
      'promo-call-to-action--vertical': isMsb || isBmsm,
    });

  const toBeSelectedItemId = bogoSelectedProduct?.itemId || freeItemInCart?.itemId;

  return (
    <>
      {!(isBogo && singleItemIdToDisplay) && (
        <div
          role="button"
          tabIndex={0}
          className={promoCallToActionClasses}
          data-testid="promo-call-to-action"
          onClick={isCallToActionEnabled ? handleClick : undefined}
          onMouseEnter={(!isAppleTouchDevice && isCallToActionEnabled) ? onPromoCtaHover : undefined}
          aria-label="Open Promotion Drawer"
        >
          <div className="promo-call-to-action__messaging">
            <MessagingContainer />
            {hasProducts && (
              <div
                data-testid="promo-icon-open"
                className="promo-icon promo-icon-open"
              />
            )}
          </div>
          <InfoContainer />
        </div>
      )}
      {singleItemIdToDisplay && (
        <>
          {isBogo && <div className="promo-call-to-action__single-reward-message u__bold">Free Gift with Purchase</div>}
          <PromoPod
            key={singleItemIdToDisplay}
            itemId={singleItemIdToDisplay}
            selected={isBogo && !!toBeSelectedItemId}
            displayPosition="1"
            isInPromoList={false}
          />
        </>
      )}
    </>
  );
};

PromoCallToAction.displayName = 'PromoCallToAction';

PromoCallToAction.propTypes = {
  onPromoCtaHover: func
};

PromoCallToAction.defaultProps = {
  onPromoCtaHover: noop
};
